import {signOut} from 'firebase/auth';
import {getFirebaseAuth} from '@local/logics/firebase/auth';
import {DispatchHolder} from '@local/logics/global/dispatchHolder';
import {loginActions} from '@local/redux/slice/pages/login';

export class LogoutInteractor {
  handle = async () => {
    DispatchHolder.dispatch(loginActions.clear());
    await signOut(getFirebaseAuth());
  };
}
